import { __extends } from "tslib";
import memoizeOne from "memoize-one";
import React, { useContext } from "react";
import { t, tf, tn, tnf, translationsToCatalogs, } from "../localization";
import { createContextHOC, getBrowserLocale, RTL_LOCALES } from "../utils";
var TargemContext = React.createContext({
    direction: "ltr",
    locale: "en",
    t: function () { return ""; },
    tn: function () { return ""; },
    tf: function () { return ""; },
    tnf: function () { return ""; },
});
var Provider = TargemContext.Provider, Consumer = TargemContext.Consumer;
export { Provider as RawLocaleProvider };
var lastValue;
export var translators = {
    get t() {
        return lastValue.t;
    },
    get tn() {
        return lastValue.tn;
    },
    get tf() {
        return lastValue.tf;
    },
    get tnf() {
        return lastValue.tnf;
    },
};
var TargemProvider = /** @class */ (function (_super) {
    __extends(TargemProvider, _super);
    function TargemProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getValue = memoizeOne(_this.getNewValue.bind(_this));
        _this.getCatalogs = memoizeOne(function (translations) {
            return translationsToCatalogs(translations);
        });
        _this.getLocale = memoizeOne(function (translations, locale) {
            return locale || _this.getDefaultLocale(translations);
        });
        _this.getDefaultLocale = memoizeOne(function (translations) {
            var _a = _this.props, defaultLocale = _a.defaultLocale, detectLocale = _a.detectLocale;
            if (!detectLocale && defaultLocale) {
                return defaultLocale;
            }
            var locales = _this.getSupportedLocales(translations);
            return getBrowserLocale(locales, defaultLocale);
        });
        _this.getSupportedLocales = memoizeOne(function (translations) {
            return Object.keys(translations);
        });
        _this.getDirection = memoizeOne(function (locale, direction) {
            if (direction) {
                return direction;
            }
            return RTL_LOCALES.includes(locale) ? "rtl" : "ltr";
        });
        _this.changeBodyDir = memoizeOne(function (direction) {
            var _a = _this.props, controlBodyDir = _a.controlBodyDir, setBodyDir = _a.setBodyDir;
            if (!controlBodyDir) {
                return;
            }
            if (setBodyDir) {
                setBodyDir(direction);
                return;
            }
            if (typeof document !== "undefined") {
                document.body.dir = direction;
            }
        });
        return _this;
    }
    TargemProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, translations = _a.translations, locale = _a.locale, direction = _a.direction;
        var value = this.getValue(translations, locale, direction);
        this.changeBodyDir(value.direction);
        return React.createElement(Provider, { value: value }, children);
    };
    TargemProvider.prototype.getNewValue = function (propsTranslations, propsLocale, propsDirection) {
        var locale = this.getLocale(propsTranslations, propsLocale);
        var direction = this.getDirection(locale, propsDirection);
        var catalogs = this.getCatalogs(propsTranslations);
        var value = {
            locale: locale,
            direction: direction,
            t: t(catalogs, locale),
            tn: tn(catalogs, locale),
            tf: tf(catalogs, locale),
            tnf: tnf(catalogs, locale),
        };
        lastValue = value;
        return value;
    };
    TargemProvider.defaultProps = {
        controlBodyDir: true,
        detectLocale: true,
    };
    return TargemProvider;
}(React.PureComponent));
export { TargemProvider };
export var withLocale = createContextHOC(Consumer);
export var useLocale = function () { return useContext(TargemContext); };
export default TargemProvider;
//# sourceMappingURL=TargemProvider.js.map